
import { Contact, Deal, Activity, SalesRep, SalesTeam } from './types';

export const INDUSTRIES = ["AI", "반도체", "전기전자", "스마트팩토리", "소프트웨어", "공유압", "로봇", "자동제어"];

const TEAM_ROSTER: Record<string, string[]> = {
  '마케팅본부': ['본부장', '최마케'],
  '영업1팀': ['김관리', '정사원'],
  '영업2팀': ['박대리', '강대리'],
  '영업3팀': ['이주임', '한사원'],
  '해외사업팀': ['최팀장', 'James', 'Yuki']
};

export const INITIAL_SALES_REPS: SalesRep[] = Object.entries(TEAM_ROSTER).flatMap(([team, names], teamIdx) => 
  names.map((name, idx) => ({
    id: `r_${teamIdx}_${idx}`,
    name: name,
    team: team as SalesTeam
  }))
);

// 영업 기회에 등장하는 모든 거래처를 고객으로 등록 (고객등급 포함)
const MOCK_COMPANIES = [
  { name: '(주)테크솔루션', region: '경기', grade: 'S' as const, rep: '영업1팀 김관리' },
  { name: '법무법인 정의', region: '서울', grade: 'A' as const, rep: '영업1팀 김관리' },
  { name: '에듀퓨처', region: '전남', grade: 'C' as const, rep: '영업3팀 이주임' },
  { name: '스마트제조혁신단', region: '충남', grade: 'S' as const, rep: '영업2팀 박대리' },
  { name: '한국로봇연구소', region: '대전', grade: 'A' as const, rep: '연구소장 최팀장' },
  { name: '미래자동차', region: '울산', grade: 'B' as const, rep: '영업2팀 강대리' },
  { name: '글로벌반도체', region: '인천', grade: 'S' as const, rep: '해외사업팀 James' },
  { name: '서울시교육청', region: '서울', grade: 'B' as const, rep: '영업1팀 정사원' }
];

export const MOCK_CONTACTS: Contact[] = MOCK_COMPANIES.map((c, i) => ({
  id: `c${i + 1}`,
  name: `담당자 ${i + 1}`,
  email: `user${i + 1}@${c.name.includes('(') ? 'corp' : 'org'}.com`,
  phone: `010-1234-567${i}`,
  company: c.name,
  role: i % 2 === 0 ? '구매팀장' : '기술이사',
  grade: c.grade,
  salesRep: c.rep,
  region: c.region,
  lastContactDate: '2024-03-01',
  status: 'Active',
  notes: `${c.name} 프로젝트 추진 중`
}));

const generateMockDeals = (): Deal[] => {
  const deals: Deal[] = [];
  const baseYear = new Date().getFullYear();
  const stagesList = ['Lead', 'Proposal', 'Specification', 'Procurement', 'Closed Won'];

  // 각 월별로 골고루 데이터 생성 (테스트용)
  for (let month = 0; month < 12; month++) {
    MOCK_CONTACTS.forEach((contact, i) => {
      // 60% 확률로 해당 달에 영업 기회 생성
      if (Math.random() > 0.4) {
        const stage: any = stagesList[Math.floor(Math.random() * stagesList.length)];
        const val = (Math.floor(Math.random() * 50) + 10) * 1000000;
        const productAmount = Math.floor(val * 0.7);
        const itemAmount = val - productAmount;

        deals.push({
          id: `d_gen_${month}_${i}`,
          title: `${contact.company} ${INDUSTRIES[i % INDUSTRIES.length]} 도입 건`,
          value: val,
          productAmount: productAmount,
          itemAmount: itemAmount,
          stage: stage,
          contactId: contact.id,
          expectedCloseDate: `${baseYear}-${String(month + 1).padStart(2, '0')}-15`,
          probability: stage === 'Closed Won' ? 100 : stage === 'Procurement' ? 80 : 40,
          salesRep: contact.salesRep,
          poNo: `PO-${month + 1}${i}`,
          projNo: `PRJ-${month + 1}${i}`,
          industry: INDUSTRIES[i % INDUSTRIES.length]
        });
      }
    });
  }
  return deals;
};

export const MOCK_DEALS: Deal[] = generateMockDeals();

export const MOCK_ACTIVITIES: Activity[] = [
  { id: 'a1', type: 'Call', description: '협상 통화', date: '2024-03-05', contactId: 'c1', createdBy: '김관리' },
];
